<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="!match_detail">
        <p>No Detail Found</p>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="table-responsive">
            <div class="match-table info">
                <div class="thead">
                    <div class="table-row align-items-end">
                        <div class="th">match info</div>
                        <div class="th"></div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row">
                            <div class="td">
                                <span class="title">Match</span>
                            </div>
                            <div class="td">{{match_detail.matchno}}</div>
                        </div>
                        <div class="table-row">
                            <div class="td">
                                <span class="title">Series</span>
                            </div>
                            <div class="td">{{match_detail.season}}</div>
                        </div>
                        <div class="table-row">
                            <div class="td">
                                <span class="title">Match Type</span>
                            </div>
                            <div class="td">{{match_detail.matchtype}}</div>
                        </div>
                        <div class="table-row">
                            <div class="td">
                                <span class="title">Date / Time</span>
                            </div>
                            <div class="td">{{ match_detail.gmt_datetime | formatDate }}</div>
                        </div>
                        <div class="table-row" v-if="match_detail.toss_win">
                            <div class="td">
                                <span class="title">Toss</span>
                            </div>
                            <div class="td" >{{match_detail.toss_win}} opt to {{match_detail.elected}}</div>
                        </div>
                        <div class="table-row" v-if="match_detail.pitch_batting && match_detail.pitch_batting != 'N/A'">
                            <div class="td">
                                <span class="title">Pitch Report (Batting)</span>
                            </div>
                            <div class="td">{{match_detail.pitch_batting}}</div>
                        </div>
                        <div class="table-row" v-if="match_detail.pitch_bowling && match_detail.pitch_bowling != 'N/A'">
                            <div class="td">
                                <span class="title">Pitch Report (Bowling)</span>
                            </div>
                            <div class="td">{{match_detail.pitch_bowling}}</div>
                        </div>
                        <div class="table-row" v-if="umpires.length">
                            <div class="td">
                                <span class="title">Umpires</span>
                            </div>
                            <div class="td">
                                <span v-for="(umpire,index) in umpires" :key="umpire.id">
                                    <span v-if="index != 0">,</span>
                                    {{ umpire.name }}
                                </span>
                            </div>
                        </div>
                        <div class="table-row" v-if="refrees.length">
                            <div class="td">
                                <span class="title">Referee</span>
                            </div>
                            <div class="td">
                                <span v-for="refree in refrees" :key="refree.id">
                                    {{ refree.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive" v-if="match_detail.stadium">
            <div class="match-table info">
                <div class="thead">
                    <div class="table-row align-items-end">
                        <div class="th">Venue guide</div>
                        <div class="th"></div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" v-if="match_detail.stadium.name">
                            <div class="td">
                                <span class="title">Stadium</span>
                            </div>
                            <div class="td">{{match_detail.stadium ? match_detail.stadium.name : ''}}</div>
                        </div>
                        <div class="table-row" v-if="match_detail.stadium.city">
                            <div class="td">
                                <span class="title">City</span>
                            </div>
                            <div class="td">{{match_detail.stadium ? match_detail.stadium.city : ''}}</div>
                        </div>
                        <div class="table-row" v-if="match_detail.stadium.capacity">
                            <div class="td">
                                <span class="title">Capacity</span>
                            </div>
                            <div class="td">{{match_detail.stadium ? match_detail.stadium.capacity : ''}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'MatchInfo',

        components: {},

        data() {
            return {
                match_detail: [],
                stadium:[]
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                
                 return {
                "@context": "https://schema.org",
                '@type': 'Organization',
                name: this.stadium.name,
                logo: process.env.BASE_URL + 'public/images/logo1280x720.png',
                "location": {
                    "@type": "Place",
                    "name": this.stadium.name + ", " + this.stadium.city + ", " + this.stadium.country,
                    "address": {
                        "@type": "PostalAddress",
                        "name": this.stadium.name + ", " + this.stadium.city + ", " + this.stadium.country,
                    }
                }
            }
        },
        
        computed: {
            refrees() {
                if (!this.match_detail)
                    return []
                return this.match_detail.umpires.filter(function (umpire) {
                    return umpire.pivot.position == 'referee'
                })
            },

            umpires() {
                if (!this.match_detail)
                    return []
                return this.match_detail.umpires.filter(function (umpire) {
                    return umpire.pivot.position != 'referee'
                })
            }
        },
        metaInfo() {
            if (!Components['MatchDetail'])
                return
            let title = Components['MatchDetail'].setTitle() + "Match Info - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - Planet Cricket";
            let description = "Match Info - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - Planet Cricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getMatchDetail();
            }
        },
        mounted() {
            this.getMatchDetail();
        },

        methods: {
            getMatchDetail() {
                return this.$axios.get(this.$MATCH_INFO_API.replace(':match', this.$route.params.match))
                        .then(response => {
                            this.is_data_ready = true;
                            this.match_detail = response.data.result.match;
                            this.stadium = this.match_detail.stadium;
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>
